<template>
  <div>
    <el-form>
      <column-box :source="dataList" :list="keyList" column="2" labelWidth="140"></column-box>
      <el-form-item label="营业执照照片:" class="alone btom" label-width="140px">
        <div class="imgs" v-if="dataList.businessLicenceUrl">
          <EnlargeImg :imgSrc="dataList.businessLicenceUrl" />
        </div>
        <div v-else>--</div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  name: 'servierDetail',
  props: {
    addEditFormData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      keyList: [
        { key: 'id', name: '服务商ID' },
        { key: 'stateName', name: '服务商状态' },
        { key: 'name', name: '服务商名称' },
        { key: 'serviceTypeName', name: '服务类型' },
        { key: 'contacts', name: '联系人' },
        { key: 'contactTel', name: '联系电话' },
        { key: 'creditCode', name: '统一社会信用代码' },
        { key: 'accountName', name: '账户名称' },
        { key: 'accountNo', name: '开户账号' },
        { key: 'bankName', name: '开户银行' },
        { key: 'address', name: '客户地址', alone: true },
        { key: 'expireDate', name: '服务到期时间' },

        { key: 'companyName', name: '单位名称' },
        { key: 'legalPersonName', name: '法人姓名' },
        { key: 'idCardNo', name: '法人身份证号' },
        { key: 'taxTypeName', name: '税票类型' },

        { key: 'taxNo', name: '税号' },
        { key: 'registration', name: '登记机关' },
        { key: 'businessRegistrationNo', name: '工商注册号' },
        { key: 'organizationCode', name: '组织机构代码' },
        { key: 'registeredAddress', name: '注册地址OCR', alone: true },
        { key: 'remarks', name: '备注' },
      ],
      dataList: this.addEditFormData,
    }
  },
  watch: {
    addEditFormData: {
      immediate: true,
      handler(val) {
        this.dataList.stateName = val.state === 0 ? '禁用' : '启用'
        // this.dataList.serviceType = val.serviceType === 1 ? '个人' : '企业'
        switch (val.serviceType) {
          case 0:
            this.dataList.serviceTypeName = '车源方'
            break
          case 1:
            this.dataList.serviceTypeName = '维修厂'
            break
          case 2:
            this.dataList.serviceTypeName = '保险公司'
            break
          case 3:
            this.dataList.serviceTypeName = '产权方'
            break
          default:
            break
        }
        this.dataList.taxTypeName = selectOption.taxTypeList[val.taxType]
        this.dataList = val
        this.dataList.businessLicenceUrl = this.getURL({ data: val.businessLicenceUrl }) || ''
      },
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
img {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
